// /**
//  * @typedef LinearTransformation
//  * @property {Object} lint_data
//  */ 

// /**
//  * @typedef NonLinearTransformation
//  * @property {Array} nlint_data - Array of ViewportCoordinates and ProjectedCoordinates
//  */

// /**
//  * @typedef GPRTransformation
//  * @property {Object} trained_data
//  */

// /**
//  * @typedef {Object} LocalizationOptions
//  * @property {String} projection
//  *      The name of the projection, currently supported values: [EPSG:3857, EPSG:3395, EPSG:6676]
//  * @property {String} transformation
//  *      The relative url of the JSON file containing the transformation data
//  * @property {GPRTransformation|NonLinearTransformation} transformation_data
//  *      The object containing the transformation data 
//  */
(function($){
    "use strict";

    /**
     * @class ABDOMap.Mapper
     * @param {Object} data - JSON data of the thin plate spline
     */
    $.Mapper = function(data) {
        this._viewport_projected = data.biharmonic.viewport_projected;
        this._projected_viewport = data.biharmonic.projected_viewport;
    };


    /**
     * Perform matrix multiplication X @ Y
     * @param {Array} X 
     * @param {Array} Y 
     * @returns {Array}
     */
    $.Mapper.prototype._matmul = function(X, Y) {
        var x_rows = X.length;
        var x_cols = X[0].length;
        var y_rows = Y.length;
        var y_cols = Y[0].length;

        if (x_cols != y_rows) {
            throw "x_cols != y_rows (" + x_cols + " != " + y_rows + ")";
        } 

        var i,j,k;
        var res = new Array(x_rows);
        for (i = 0; i < x_rows; i++) {
            res[i] = new Array(y_cols);
            for (j = 0; j < y_cols; j++) {
                // row-col vector wise dot product
                res[i][j] = 0.0;
                for (k = 0; k < x_cols; k++) { 
                    res[i][j] += X[i][k] * Y[k][j]; 
                }
            }
        }

        return res; 
    };  

    /**
     * Get a matrix Transpose
     * @param {Array} X 
     * @returns {Array}
     */
    $.Mapper.prototype._T = function(X) { 
        var x_rows = X.length;
        var x_cols = X[0].length;
        
        var res = new Array(x_cols);

        var i,j;  
        for (i = 0; i < x_cols; i++) {
            res[i] = new Array(x_rows);
            for (j = 0; j < x_rows; j++) { 
                res[i][j] = X[j][i];
            } 
        }

        return res; 
    };

    /**
     * Returns a coordinates matrix in homogeneous coordinates, it expects data in rows
     * @param {Array} X 
     * @returns 
     */
    $.Mapper.prototype._homogeneous = function(X) { 
        var x_rows = X.length;
        var x_cols = X[0].length;
        
        var res = new Array(x_rows); 
        var i,j;  
        for (i = 0; i < x_rows; i++) {
            res[i] = new Array(x_cols+1);
            for (j = 0; j < x_cols+1; j++) { 
                if (j < x_cols) {
                    res[i][j] = X[i][j];
                }
                else {
                    res[i][j] = 1;
                }
            } 
        }

        return res; 
    };

    /**
     * Euclidean distance between 2 points
     * @param {Array} X 
     * @param {Array} Y 
     * @returns {Number}
     */
    $.Mapper.prototype._eucd = function(X,Y) { 
        var n = X.length; 

        var sum = 0;
        var i;
        for(i = 0; i < n; i++) {
            sum += Math.pow(X[i] - Y[i], 2);
        }

        return Math.sqrt(sum);
    }

    
    /**
     * Computes the biharmonic function of the thin plate spline, it expects a distance between a query point and control points
     * @param {Number} x 
     * @returns {Number}
     */
    $.Mapper.prototype._biharmonic_fn = function(x) {
        if (x >= 1) {
            return x*x * Math.log(x);
        }
        else { 
            return x * Math.log(Math.pow(x,x));
        }
    }; 


    /**
     * Computes the codistance of 2 matrices, it expects data in rows.
     * 
     * If fn is defined, returns only the euclidean distance, otherwise fn is applied to the euclidean distance before assignment
     * @param {Array} X 
     * @param {Array} Y 
     * @param {Function} fn Function to apply after getting the euclidean distance
     * @returns 
     */
    $.Mapper.prototype._cdist = function(X,Y, fn) {
        var m = X.length;
        var n = Y.length;

        var res = new Array(m);
        var i,j;
        for(i = 0; i < m; i++) {
            res[i] = new Array(n); 
            for(j = 0; j < n; j++) {
                if (typeof(fn) === "undefined") {
                    res[i][j] = this._eucd(X[i],Y[j]);
                }
                else {
                    res[i][j] = fn(this._eucd(X[i],Y[j]));
                }
            }
        }

        return res;
    }; 

    /**
     * Computes the Kernel of a thin plate spline given a codistance matrix and query points
     * @param {Array} A codistance matrix
     * @param {Array} query query points
     * @returns 
     */
    $.Mapper.prototype._K = function(A, query) {
        // K = np.hstack([A, np.ones((n, 1)), batch])
        var A_len = A[0].length;
        var K_cols = A_len + 1 + query[0].length;
        var K_rows = A.length; // or query.length

        var K = new Array(K_rows);
        var i,j;
        for(i = 0; i < K_rows; i++) {
            K[i] = new Array(K_cols); 

            for(j = 0; j < K_cols; j++) {
                if (j < A_len) { 
                    K[i][j] = A[i][j];
                }
                else if (j == A_len) {
                    K[i][j] = 1;
                }
                else {
                    K[i][j] = query[i][j-A_len-1];
                }
            }
        }

        return K;
    };

    /**
     * Dehomogenize array. Removes the last column of the array
     * @param {Array} X 
     * @returns 
     */
    $.Mapper.prototype._dehomogenize = function(X) { 
        var new_X_rows = X.length;
        var new_X_cols = X[0].length - 1;

        var new_X = new Array();
        var i,j;

        for(i = 0; i < new_X_rows; i++) {
            new_X[i] = new Array(new_X_cols);
            for(j = 0; j < new_X_cols; j++) {
                new_X[i][j] = X[i][j];
            } 
        }

        return new_X;
    };

    /**
     * Transforms 2 coordinates given a transformation
     * @param {Number} x 
     * @param {Number} y 
     * @param {Object} transformation 
     * @returns {Array<Number>}
     */
    $.Mapper.prototype._transform = function(x,y, transformation) {
        var pt = [[x, y]];
        var pt_homogeneous = this._homogeneous(pt);
        var transformed_pt = this._dehomogenize(this._T(this._matmul(transformation.T, this._T(pt_homogeneous))));

        var cdist = this._cdist(transformed_pt, transformation.control, this._biharmonic_fn);

        var K = this._K(cdist, transformed_pt);

        return this._matmul(K, transformation.coefficients)[0];
    };

    /**
     * Transform projected coordinates to viewport coordinates
     * @param {Number} proj_x 
     * @param {Number} proj_y 
     * @returns {Array<Number>}
     */
    $.Mapper.prototype.toViewport = function(proj_x, proj_y) {
        return this._transform(proj_x, proj_y, this._projected_viewport);
    };

    /**
     * Transform viewport coordinates to projected coordinates
     * @param {Number} x 
     * @param {Number} y 
     * @returns {Array<Number>}
     */
    $.Mapper.prototype.toProjected = function(x, y) {
        return this._transform(x, y, this._viewport_projected);
    };

    /**
     * @class Localization
     * @memberof ABDOMap
     * @param {LocalizationOptions} options 
     */
    $.Localization = function(options) {
        // init projections
        this._projections = [
            // spherical mercator
            ["EPSG:3857","+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs"],
            // world mercator
            ["EPSG:3395","+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs"],

            //# JGD2011 / Japan Plane Rectangular CS I
            ["EPSG:6669", "+proj=tmerc +lat_0=33 +lon_0=129.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs"],
            //# JGD2011 / Japan Plane Rectangular CS II
            ["EPSG:6670", "+proj=tmerc +lat_0=33 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs"],
            //# JGD2011 / Japan Plane Rectangular CS III
            ["EPSG:6671", "+proj=tmerc +lat_0=36 +lon_0=132.1666666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs"],
            //# JGD2011 / Japan Plane Rectangular CS IV
            ["EPSG:6672", "+proj=tmerc +lat_0=33 +lon_0=133.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs"],
            //# JGD2011 / Japan Plane Rectangular CS V
            ["EPSG:6673", "+proj=tmerc +lat_0=36 +lon_0=134.3333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs"],
            //# JGD2011 / Japan Plane Rectangular CS VI
            ["EPSG:6674", "+proj=tmerc +lat_0=36 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs"],
            //# JGD2011 / Japan Plane Rectangular CS VII
            ["EPSG:6675", "+proj=tmerc +lat_0=36 +lon_0=137.1666666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs"],
            //# JGD2011 / Japan Plane Rectangular CS VIII
            ["EPSG:6676", "+proj=tmerc +lat_0=36 +lon_0=138.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs"],
            //# JGD2011 / Japan Plane Rectangular CS IX
            ["EPSG:6677", "+proj=tmerc +lat_0=36 +lon_0=139.8333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs"],
            //# JGD2011 / Japan Plane Rectangular CS X
            ["EPSG:6678", "+proj=tmerc +lat_0=40 +lon_0=140.8333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs"],
            //# JGD2011 / Japan Plane Rectangular CS XI
            ["EPSG:6679", "+proj=tmerc +lat_0=44 +lon_0=140.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs"],
            //# JGD2011 / Japan Plane Rectangular CS XII
            ["EPSG:6680", "+proj=tmerc +lat_0=44 +lon_0=142.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs"],
            //# JGD2011 / Japan Plane Rectangular CS XIII
            ["EPSG:6681", "+proj=tmerc +lat_0=44 +lon_0=144.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs"],
            //# JGD2011 / Japan Plane Rectangular CS XIV
            ["EPSG:6682", "+proj=tmerc +lat_0=26 +lon_0=142 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs"],
            //# JGD2011 / Japan Plane Rectangular CS XV
            ["EPSG:6683", "+proj=tmerc +lat_0=26 +lon_0=127.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs"],
            //# JGD2011 / Japan Plane Rectangular CS XVI
            ["EPSG:6684", "+proj=tmerc +lat_0=26 +lon_0=124 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs"],
            //# JGD2011 / Japan Plane Rectangular CS XVII
            ["EPSG:6685", "+proj=tmerc +lat_0=26 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs"],
            //# JGD2011 / Japan Plane Rectangular CS XVIII
            ["EPSG:6686", "+proj=tmerc +lat_0=20 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs"],
            //# JGD2011 / Japan Plane Rectangular CS XIX
            ["EPSG:6687", "+proj=tmerc +lat_0=26 +lon_0=154 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs"],
        ]; 
        proj4.defs(this._projections);

        // init flags and constants
        this._has_lint_data = false;
        this._has_nlint_data = false;
        this._has_trained_data = false;
        this._has_biharmonic_data = false;
        this._has_reference_points = false;
        this._RAD2DEG = 180 / Math.PI; 
        this._PI_4 = Math.PI / 4;
        this.is_ready = false;
        this._use_triangulation = false;

        this._options = options || {}; 
    };

    $.Localization.prototype = {
        init: function() { 
            this._transformation_file = this._options.transformation || 'abdo_location/js/merc2vp.json';
            this._transformation_data = this._options.transformation_data || {};

            if (typeof(this._options.use_triangulation) !== "undefined") {
                this._use_triangulation = this._options.use_triangulation;
            }
            
            var projection_name =  this._options.projection || this._projections[0][0]; //first projection is the default
            this._projection = proj4('WGS84', projection_name) || null;
            
            this._load_transformation(this._after_load_transformation.bind(this)); 
        }, 

        /**
         * Computes the distance between pt_a and pt_b by converting them as viewport coordinates to their respective coordinate system
         * and estimating their euclidean distance
         * 
         * @param {OpenSeadragon.Point} pt_a 
         * @param {OpenSeadragon.Point} pt_b 
         * @returns {Number|false}
         */
        point_distance: function(pt_a, pt_b) {
            var projected_a = this.vp2proj(pt_a.x, pt_a.y);
            var projected_b = this.vp2proj(pt_b.x, pt_b.y);
            if (Array.isArray(projected_a) && Array.isArray(projected_b)) {
                var projected_pt_a = new OpenSeadragon.Point(projected_a[0], projected_a[1]);
                var projected_pt_b = new OpenSeadragon.Point(projected_b[0], projected_a[1]);

                return projected_pt_a.distanceTo(projected_pt_b);
            }
            return false;
        },

        _after_load_transformation: function() { 
            
            // すでに学習しているデータを回復する
            if ('nlint_data' in this._transformation_data) {
                var obj = this._transformation_data.nlint_data || null;
                if (obj) {
                    this._restore(obj);
                    this._has_nlint_data = true;
                }
            }
            // 学習したデータがない時
            else if ('lint_data' in this._transformation_data && this._transformation_data.lint_data.length >= 2) {
                this._load_from_lint_data(this._transformation_data.lint_data);
            }
            else if ('trained_data' in this._transformation_data) {
                // use GPR trained from scikit-learn
                this._load_from_trained_data(this._transformation_data);
            }
            else if ("biharmonic" in this._transformation_data) {
                // use TPS
                this._load_from_biharmonic_data(this._transformation_data);
            }

            if (Array.isArray(this._x_coordinates) && this._x_coordinates.length > 0 &&
                Array.isArray(this._y_coordinates) && 
                Array.isArray(this._proj_x_coordinates) &&
                Array.isArray(this._proj_y_coordinates)) {
                    this._has_reference_points = true;
            }

            this._has_linear_transformation = false;
            this._linear_transformation = null;
            if ('transformation' in this._transformation_data) {
                this._has_linear_transformation = true;
                this._linear_transformation = this._transformation_data.transformation;
            }

            this.is_ready = true; 
            this.emit('ready'); 
        },

        _load_transformation: function(callback) {
            var self = this;
            var request = new XMLHttpRequest();
            var url = this._transformation_file;
            
            request.addEventListener('load', function(evt) {
                if (request.status == 0 || (request.status >= 200 && request.status < 400)) {
                    self._transformation_data = JSON.parse(this.responseText);  
                    callback();

                    if (typeof(abdo_osd) !== "undefined") {
                        abdo_osd.addCache(url);
                    }
                }
            });

            request.open('GET', url, true);
            request.send(); 
        },  

        /**
         * Returns the center of the GPS mapping.
         * 
         * When transformation is linear returns [0.5,0.5] as it is unbounded.
         * When transformation is nonlinear (Gaussian Process), it returns the median point of its reference points
         * @returns {OpenSeadragon.Point}
         */
        get_viewport_center: function() {
            if (typeof(this._vp_center) === "undefined")
            { 
                // linear transformation is unbounded, center at [0.5,0.5] by default
                this._vp_center = new OpenSeadragon.Point(0.5, 0.5);
                
                // if transformation is nonlinear use the median 
                if (this._has_nlint_data || this._has_trained_data ) { 
                    this._vp_center = new OpenSeadragon.Point(this._get_median(this._x_coordinates), this._get_median(this._y_coordinates));
                }
            }

            return this._vp_center;
        },

        /**
         * Returns the bounding box of the transformation.
         * 
         * When linear it is unbounded and it returns a [0,0, 1,1] (top,left,width,height) bounding box
         * When non-linear it returns the Axis Aligned Bounding Box of the viewport coordinate references
         * @returns {OpenSeadragon.Rect}
         */
        get_viewport_rect: function() {
            if (typeof(this._vp_bounding_rect) === "undefined") {
                // linear transformation is unbounded, use all viewport rect
                if (this._has_linear_transformation) {
                    this._vp_bounding_rect = new OpenSeadragon.Rect(0,0, 1,1);
                }
                else if (this._has_nlint_data || this._has_trained_data) {
                    // defines the Axis Aligned Bounding Box in this._vp_bounding_rect
                    this._estimate_bounds();
                }
            }

            return this._vp_bounding_rect;
        },

        _estimate_scale_linear: function() {
            var delta = 0.1;
            var center = new OpenSeadragon.Point(0.5,0.5);
            var center_delta = new OpenSeadragon.Point(center.x+delta,center.y+delta);
            var distance_vp = center.distanceTo(center_delta);

            var center_lonlat = this.vp2lonlat(center.x, center.y);
            var center_delta_lonlat = this.vp2lonlat(center_delta.x, center_delta.y);

            var center_proj  = this._projection.forward(center_lonlat);
            center_proj = new OpenSeadragon.Point(center_proj[0], center_proj[1]);

            var center_delta_proj  = this._projection.forward(center_delta_lonlat);
            center_delta_proj = new OpenSeadragon.Point(center_delta_proj[0], center_delta_proj[1]);

            var distance_proj = center_proj.distanceTo(center_delta_proj);

            this._map_scale = distance_proj / distance_vp; 
        },

        /**
         * Returns the median value of an array of numbers
         * @param {Array<Number>} numbers_array 
         * @returns {Number}
         */
        _get_median: function(numbers_array) {
            var sorted = []; 
            var i;
            for(i = 0; i < numbers_array.length; i++) {
                if (!isNaN(numbers_array[i])) {
                    sorted.push(numbers_array[i]);
                }
            }
            
            sorted.sort(function(a,b){ return a-b; });
            
            if (sorted.length % 2 == 0) {
                return sorted[Math.floor(sorted.length / 2)];
            }
            else {
                var median_index = Math.floor(sorted.length / 2);
                return (sorted[median_index] + sorted[median_index+1])/2;
            }
            
        },

        /**
         * Returns the mean value of an array of numbers
         * @param {Array<Number>} numbers_array 
         * @returns {Number}
         */
         _get_mean: function(numbers_array) {
            var i, n=numbers_array.length, sum = 0, count = 0;
            for(i = 0; i < n; i++) {
                if (!isNaN(numbers_array[i])) {
                    sum += numbers_array[i];
                    count++;
                }

            }
            return sum / count; 
        },

        _estimate_scale_nonlinear: function () {
            var n = this._x_coordinates.length;
            
            var i,j,distance_vp,distance_proj;
            var scales = [];

            for(i = 0; i < n; i++) { 
                for(j = 0; j < n; j++) {
                    if (i != j) {
                        distance_vp   = Math.sqrt(Math.pow(this._x_coordinates[i] - this._x_coordinates[j], 2) + Math.pow(this._y_coordinates[i] - this._y_coordinates[j], 2));
                        distance_proj = Math.sqrt(Math.pow(this._proj_x_coordinates[i] - this._proj_x_coordinates[j], 2) + Math.pow(this._proj_y_coordinates[i] - this._proj_y_coordinates[j], 2));
                        scales.push(distance_proj / distance_vp);
                    }
                }
            } 
            
            this._map_scale = this._get_median(scales); 
            // this._map_scale = this._get_mean(scales); 
        },

        /**
         * Guess the scale by measuring the distance between reference points in the map
         * Since it can be very expensive to compute, the initially computed value is stored as a singleton
         * @returns {Number} scale in [meters]/[viewport units]
         */
        get_scale: function() {
            
            if (typeof(this._map_scale) === "undefined") {
                // if transformation is linear, we can use the center map as reference and a delta to get an approximate size
                if (this._has_linear_transformation) {
                    this._estimate_scale_linear();
                }
                else {
                    this._estimate_scale_nonlinear(); 
                }
            }
             
            return this._map_scale; 
        },

        _triangulate: function( from_a, from_b, from_c, query_pt, to_a, to_b, to_c )
        {
            var sub = function(a,b) {
                return {x: a.x-b.x, y: a.y-b.y};
            };
            var mul = function(a,b) {
                return {x: a.x*b, y:a.y*b};
            };
            var add = function(a,b) {
                return {x: a.x+b.x, y: a.y+b.y};
            };

            var scale = function ( from_a, from_b, from_c, query_pt )
            { 
                var o, a, s, u, l, c, h = {
                    A: 0,
                    B: 0
                }; 
        
                var vec_a_c = sub( from_a, from_c );
                var vec_b_c = sub( from_b, from_c );
                var vec_q_c = sub( query_pt, from_c );

                if (0 === vec_a_c.x && 0 === vec_b_c.x || 0 !== vec_a_c.x && 0 !== vec_b_c.x && vec_a_c.y / vec_a_c.x == vec_b_c.y / vec_b_c.x) {
                    return null;
                }

                if (vec_a_c.x !== 0) {
                    l = vec_a_c.y / vec_a_c.x;
                    o = l * vec_q_c.x;
                    a = vec_q_c.y - o;
                    if (vec_b_c.x !== 0) {
                        c = vec_b_c.y / vec_b_c.x;
                        s = a / ( c - l );
                        h.B = s / vec_b_c.x;
                        // h.B = (vec_q_c.y - l*vec_q_c.x)/(vec_b_c.y - l*vec_b_c.x); 
                    }
                    else {
                        s = 0;
                        u = vec_q_c.y - o;
                        h.B = u / vec_b_c.y;
                    } 
                    h.A = ( vec_q_c.x - s ) / vec_a_c.x;
                    // h.A = ( vec_q_c.x * (1 - l) - vec_q_c.y ) / vec_a_c.x;
                }
                else if (vec_b_c.x !== 0) {
                    c = vec_b_c.y / vec_b_c.x;
                    o = c * vec_q_c.x;
                    a = vec_q_c.y - o;

                    if (vec_a_c.x !== 0) {
                        l = vec_a_c.y / vec_a_c.x;
                        s = a / ( l - c );
                        h.A = s / vec_a_c.x;
                    }
                    else {
                        s = 0;
                        u = vec_q_c.y - o;
                        h.A = u / vec_a_c.y;
                    }

                    h.B = ( vec_q_c.x - s ) / vec_b_c.x;
                }

                return h;
            }( from_a, from_b, from_c, query_pt );

            if ( scale === null )
                return null; 
            
            to_a = sub( to_a, to_c );
            to_b = sub( to_b, to_c );
            to_a = mul( to_a, scale.A );
            to_b = mul( to_b, scale.B );

            var l = add( to_a, to_b );

            return add( l, to_c );
        },

        vp2proj: function(x,y,extrapolate) {
            if (typeof(extrapolate) === "undefined") {
                extrapolate = false;
            }

            if (this._projection) {
                var merc_x, merc_y, lonlat;
                
                if (this._has_linear_transformation) {
                    merc_x = this._x2mercx(x);
                    merc_y = this._y2mercy(y);
 
                    return [merc_x, merc_y];
                }
                else if (this._has_nlint_data) {
                    var convex_hull = this._get_convex_hull();
                    var pt = new OpenSeadragon.Point(x,y);
                    if (!extrapolate && !this._point_in_convex_hull(pt, convex_hull)) { 
                        return false;
                    }

                    merc_x = this._unscale($.gp.predict(x,y,this._xy2mercx_model), this._min_proj_x, this._max_proj_x);
                    merc_y = this._unscale($.gp.predict(x,y,this._xy2mercy_model), this._min_proj_y, this._max_proj_y);

                    var projected_convex_hull = this._get_projected_convex_hull();
                    var proj_pt = new OpenSeadragon.Point(merc_x,merc_y);
                    if (!extrapolate && !this._point_in_convex_hull(proj_pt, projected_convex_hull)) { 
                        return false;
                    }

                    lonlat = this._projection.inverse([merc_x, merc_y]); 
                    return [merc_x, merc_y];
                } 
                else if (this._has_reference_points && this._use_triangulation) {
                    var nearest_three = this.getNearestTriangle(x, y, false);

                    var from_a = {x: nearest_three[0].x, y: nearest_three[0].y};
                    var from_b = {x: nearest_three[1].x, y: nearest_three[1].y};
                    var from_c = {x: nearest_three[2].x, y: nearest_three[2].y};

                    var to_a = {x: nearest_three[0].proj_x, y: nearest_three[0].proj_y};
                    var to_b = {x: nearest_three[1].proj_x, y: nearest_three[1].proj_y};
                    var to_c = {x: nearest_three[2].proj_x, y: nearest_three[2].proj_y};

                    var query_pt = {x: x, y: y};

                    var triangulated = this._triangulate(from_a, from_b, from_c, query_pt, to_a, to_b, to_c);

                    return [triangulated.x, triangulated.y]; 
                }
                else if (this._has_trained_data) { 
                    if (!extrapolate && !this._point_in_convex_hull(new OpenSeadragon.Point(x, y))) { 
                        return false;
                    }
                    
                    var projxy = this._gps_mapping_model.to_proj(x, y); 
                    return projxy;
                }
                else if (this._has_biharmonic_data) {
                    return this._biharmonic.toProjected(x, y);
                } 
            }
            
            return false;
        },

        vp2lonlat: function(x, y, extrapolate) {
            var proj = this.vp2proj(x, y, extrapolate);
            if (proj) {
                var proj_inverse = this._projection.inverse(proj);
                if (Number.isFinite(proj_inverse[0]) && Number.isFinite(proj_inverse[0])) {
                    return proj_inverse;
                }
            } 

            return false; 
        }, 
        
        proj2vp: function(proj, extrapolate) {
            if (this._has_linear_transformation) {
                return [this._mercx2x(proj[0]), this._mercy2y(proj[1])];
            }
            else if (this._has_nlint_data) {
                // validate if point is in convex hull of projected coordinates
                var projected_convex_hull = this._get_projected_convex_hull();
                var proj_pt = new OpenSeadragon.Point(proj[0], proj[1]);
                if (!extrapolate && !this._point_in_convex_hull(proj_pt, projected_convex_hull)){
                    return false;
                }
                
                proj[0] = this._scale(proj[0], this._min_proj_x, this._max_proj_x);
                proj[1] = this._scale(proj[1], this._min_proj_y, this._max_proj_y);


                var x = $.gp.predict(proj[0],proj[1],this._mercxy2x_model);
                var y = $.gp.predict(proj[0],proj[1],this._mercxy2y_model);
                
                // validate if point is in convex hull of tileimage coordinates
                var convex_hull = this._get_convex_hull();
                var pt = new OpenSeadragon.Point(x, y);
                if (!extrapolate && !this._point_in_convex_hull(pt, convex_hull)) { 
                    return false;
                }
                
                return [x, y];
            }
            else if (this._has_reference_points && this._use_triangulation) {
                var nearest_three = this.getNearestTriangle(proj[0], proj[1], true);

                var from_a = {x: nearest_three[0].proj_x, y: nearest_three[0].proj_y};
                var from_b = {x: nearest_three[1].proj_x, y: nearest_three[1].proj_y};
                var from_c = {x: nearest_three[2].proj_x, y: nearest_three[2].proj_y};

                var to_a = {x: nearest_three[0].x, y: nearest_three[0].y};
                var to_b = {x: nearest_three[1].x, y: nearest_three[1].y};
                var to_c = {x: nearest_three[2].x, y: nearest_three[2].y};
 
                var query_pt = {x: proj[0], y: proj[1]};

                var triangulated = this._triangulate(from_b, from_c, from_a, query_pt, to_b, to_c, to_a);

                return [triangulated.x, triangulated.y]; 
            }
            else if (this._has_trained_data) {
                return this._gps_mapping_model.to_vp(proj[0], proj[1]);
            }
            else if (this._has_biharmonic_data) {
                return this._biharmonic.toViewport(proj[0], proj[1]);
            }

            return false;
        },

        lonlat2proj: function(lon, lat, extrapolate) {
            if (this._projection) {
                return this._projection.forward([lon,lat]);
            }

            return false;
        },

        lonlat2vp: function(lon, lat, extrapolate) {

            if (typeof(extrapolate) === "undefined") {
                extrapolate = false;
            }

            var projected = this.lonlat2proj(lon, lat, extrapolate);
            if (projected) {   
                var vp  = this.proj2vp(projected);
                if (vp) {
                    return vp;
                }
            } 

            return false; 
        },
        
        /**
         * Returns a 2D convex hull of the points defined by the x and y arrays
         * 
         * note: assumes x and y have the same length
         * @param {Array<Number>} x 
         * @param {Array<Number>} y 
         * @returns 
         */
        _create_convex_hull: function(x, y) {
            var pts = [];
            var i;
            for(i = 0; i < x.length; i++) {
                pts.push(new OpenSeadragon.Point(x[i], y[i]));
            }

            return ConvexHull.makeHull(pts);
        },
        
        _get_projected_convex_hull: function() {
            if (typeof(ConvexHull) !== "undefined") {
                if (!Array.isArray(this._projected_convex_hull)) { 
                    this._projected_convex_hull = this._create_convex_hull(this._proj_x_coordinates, this._proj_y_coordinates);
                }
                return this._projected_convex_hull;
            }
        },

        _get_convex_hull: function() {
            if (typeof(ConvexHull) !== "undefined") {
                if (!Array.isArray(this._convex_hull)) {
                    this._convex_hull = this._create_convex_hull(this._x_coordinates, this._y_coordinates); 
                }
                return this._convex_hull;
            }

            return null;
        },

        /**
         * Estimates whether the point c is left to the line defined by a and b
         * @param {OpenSeadragon.Point} a 
         * @param {OpenSeadragon.Point} b 
         * @param {OpenSeadragon.Point} c 
         * @returns {Boolean} 
         */
        _point_left_to_line: function(a,b,c) { 
            return ((b.x - a.x)*(c.y - a.y) - (b.y - a.y)*(c.x - a.x)) > 0;
        },

        /**
         * Estimates if the point is inside the convex hull.
         * 
         * In nonlinear GPS mapping, the methods accuracy is very poor if the point is outside the convex hull of the references,
         * therefore, it is necessary to discriminate between a highly accurate mapping or a low-accuracy mapping
         * 
         * @param {OpenSeadragon.Point} pt 
         * @param {OpenSeadragon.Point} convex_hull
         * @returns 
         */
        _point_in_convex_hull: function(pt, convex_hull) {  

            if (Array.isArray(convex_hull)) {
                var i;
                var last_element_index = convex_hull.length - 1;
                for(i = 0; i < convex_hull.length; i++) {
                    var pt_a = convex_hull[i], pt_b;

                    // select pt_b as the starting point (closing the loop of the convex hull)
                    if (i == last_element_index) {
                        pt_b = convex_hull[0];
                    }
                    else {
                        pt_b = convex_hull[i+1];
                    }
                
                    /**
                     * A point who always is left the vectors defined by the convex hull (counter clockwise) . 
                     * Idea from https://stackoverflow.com/a/16906278
                     * 
                     * + <------------- +
                     *  \               ^
                     *   \     ○       / 
                     *    \           /
                     *     > + ----> +
                     */ 
                    if (!this._point_left_to_line(pt_b, pt_a, pt)) {
                        return false;
                    } 
                }

                return true;
            }

            return null;
        }, 

        // 線形的な変換のある時
        _mercy2y: function(merc_y) { 
            return merc_y * this._linear_transformation[2] + this._linear_transformation[3];     
        },
        _y2mercy: function(y) { 
            return (y - this._linear_transformation[3]) / this._linear_transformation[2]; 
        },
        _mercx2x: function(merc_x) {  
            return merc_x * this._linear_transformation[0] + this._linear_transformation[1]; 
        },
        _x2mercx: function(x) { 
            return (x - this._linear_transformation[1]) / this._linear_transformation[0];
        },

        has_elevation: function() {
            return false;
        }, 
        get_elevation: function(x, y) {  
            // 最も近い基準点の4つを選ぶ
            var nearest_pts = [];
            var i;
            for(i = 0; i < this._elevations.length; i++) {
                var vp_x = this._elevations[i][0];
                var vp_y = this._elevations[i][1];

                var distance = Math.sqrt(Math.pow((x - vp_x), 2.0) + Math.pow((y - vp_y), 2.0));
                nearest_pts.push({
                    index: i,
                    distance: distance
                });
            }
            nearest_pts.sort(function(a,b) {
                return a.distance < b.distance ? -1 : a.distance > b.distance ? 1 : 0;
            });
            nearest_pts = nearest_pts.slice(0,4);

            var A = [];
            var b = [];
            for (i = 0; i < nearest_pts.length; i++) {
                var ref_pt = this._elevations[nearest_pts[i].index]; 
                var ref_x = ref_pt[0];
                var ref_y = ref_pt[1];
                var ref_elevation = ref_pt[2];
                A.push([1, ref_x, ref_y, ref_x*ref_y]);
                b.push(ref_elevation);
            } 
            var coefficients = _Linear._solve(A, b); 
            var interpolated_elevation = coefficients[0] + coefficients[1]*x + coefficients[2]*y + coefficients[3]*x*y; 
            
            return interpolated_elevation;
        },  
        geodesic_distance: function(lat1, lon1, lat2, lon2) {
            var R = 6371e3; // 地球の半径[m]（平均）
    
            // Haversine formula
            // source: https://www.movable-type.co.uk/scripts/latlong.html
            var phi_1 = lat1 / this._RAD2DEG;
            var phi_2 = lat1 / this._RAD2DEG;
            var delta_phi = (lat2 - lat1) / this._RAD2DEG;
            var delta_lambda = (lon2 - lon1) / this._RAD2DEG;
    
            var sin_deltaphi2 = Math.sin(delta_phi/2);
            var cos_deltalambda2 = Math.sin(delta_lambda/2);
            var a = Math.pow(sin_deltaphi2, 2.0) + Math.cos(phi_1) * Math.cos(phi_2) * Math.pow(cos_deltalambda2, 2.0);
            var c = Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    
            var d = 2.0 * R * c;
    
            return d;
        },
        
        estimate_size: function(viewport_location, viewport_size) {
            var lonlat = this.vp2lonlat(viewport_location.x, viewport_location.y);
            var lonlat_delta = this.vp2lonlat(viewport_location.x+viewport_size, viewport_location.y+viewport_size);

            return this.geodesic_distance(lonlat[1], lonlat[0], lonlat_delta[1], lonlat_delta[0]);
        },

        // JSONにエクスポートするために必要なデータだけを残す
        _reduce_variogram: function(variogram) {
            var reduced_variogram = {};

            reduced_variogram.A = variogram.A;
            // reduced_variogram.K = variogram.K;
            reduced_variogram.M = variogram.M;
            reduced_variogram.n = variogram.n;
            reduced_variogram.nugget = variogram.nugget;
            reduced_variogram.range = variogram.range;
            reduced_variogram.sill = variogram.sill;

            return reduced_variogram;
        },

        _save: function() {
            // this._train();

            var obj = [];
            obj.push(this._x_coordinates);
            obj.push(this._y_coordinates);
            obj.push(this._proj_x_coordinates);
            obj.push(this._proj_y_coordinates);

            // obj.push(this._reduce_variogram(this._xy2mercx_model));
            // obj.push(this._reduce_variogram(this._xy2mercy_model));
            // obj.push(this._reduce_variogram(this._mercxy2x_model));
            // obj.push(this._reduce_variogram(this._mercxy2y_model)); 
            // obj.push(this._variogram_model);

            return obj;
        },


        _restore: function(obj) {
            var start_index = 0;
            if (obj.length == 11) { 
                this._min_proj_x = obj[0][0];
                this._max_proj_x = obj[0][1];
                this._min_proj_y = obj[1][0];
                this._max_proj_y = obj[1][1];

                start_index = 2;
                this._x_coordinates = obj[start_index+0];
                this._y_coordinates = obj[start_index+1];
                this._proj_x_coordinates = obj[start_index+2];
                this._proj_y_coordinates = obj[start_index+3];

                var i;
                for (i = 0; i < this._proj_x_coordinates.length; i++) {
                    this._proj_x_coordinates[i] = this._unscale(this._proj_x_coordinates[i], this._min_proj_x, this._max_proj_x);
                }
                for (i = 0; i < this._proj_y_coordinates.length; i++) {
                    this._proj_y_coordinates[i] = this._unscale(this._proj_y_coordinates[i], this._min_proj_y, this._max_proj_y);
                } 
            }
            else {
                this._x_coordinates = obj[start_index+0];
                this._y_coordinates = obj[start_index+1];
                this._proj_x_coordinates = obj[start_index+2];
                this._proj_y_coordinates = obj[start_index+3];
            }


            this._estimate_bounds();

            this._xy2mercx_model = obj[start_index+4];
            this._xy2mercx_model.t = this._proj_x_normalized;
            this._xy2mercx_model.x = this._x_coordinates;
            this._xy2mercx_model.y = this._y_coordinates;

            this._xy2mercy_model = obj[start_index+5];
            this._xy2mercy_model.t = this._proj_y_normalized;
            this._xy2mercy_model.x = this._x_coordinates;
            this._xy2mercy_model.y = this._y_coordinates;

            this._mercxy2x_model = obj[start_index+6];
            this._mercxy2x_model.t = this._x_coordinates;
            this._mercxy2x_model.x = this._proj_x_normalized;
            this._mercxy2x_model.y = this._proj_y_normalized;

            this._mercxy2y_model = obj[start_index+7];
            this._mercxy2y_model.t = this._y_coordinates;
            this._mercxy2y_model.x = this._proj_x_normalized;
            this._mercxy2y_model.y = this._proj_y_normalized;

            this._variogram_model = obj[start_index+8];

            // 関数を入れる
            this._xy2mercx_model = $.gp.load(this._variogram_model, this._xy2mercx_model);
            this._xy2mercy_model = $.gp.load(this._variogram_model, this._xy2mercy_model);
            this._mercxy2x_model = $.gp.load(this._variogram_model, this._mercxy2x_model);
            this._mercxy2y_model = $.gp.load(this._variogram_model, this._mercxy2y_model);

            
        },

        _normalize_projected_coordinates: function() { 
            this._proj_x_normalized = [];
            this._proj_y_normalized = [];

            this._proj_x_coordinates.forEach(function(_, index) { 
                this._proj_x_normalized.push(this._scale(this._proj_x_coordinates[index], this._min_proj_x, this._max_proj_x));
                this._proj_y_normalized.push(this._scale(this._proj_y_coordinates[index], this._min_proj_y, this._max_proj_y));
            }, this);
        },

        _estimate_bounds: function() {
            // viewport 
            this._min_x = Math.min.apply(this, this._x_coordinates);
            this._min_y = Math.min.apply(this, this._y_coordinates);
            this._max_x = Math.max.apply(this, this._x_coordinates);
            this._max_y = Math.max.apply(this, this._y_coordinates);
            this._vp_bounding_rect = new OpenSeadragon.Rect(
                this._min_x, this._min_y, this._max_x - this._min_x, this._max_y - this._min_y);
            
            // projected
            this._min_proj_x = Math.min.apply(this, this._proj_x_coordinates);
            this._min_proj_y = Math.min.apply(this, this._proj_y_coordinates);
            this._max_proj_x = Math.max.apply(this, this._proj_x_coordinates);
            this._max_proj_y = Math.max.apply(this, this._proj_y_coordinates);
            this._proj_bounding_rect = new OpenSeadragon.Rect(
                this._min_proj_x, this._min_proj_y, this._max_proj_x - this._min_proj_x, this._max_proj_y - this._min_proj_y);

            this._normalize_projected_coordinates();

            // estimate extreme indices for viewport coordinates
            var n = this._x_coordinates.length;
            this._extrema_vp_indices = [0,0];
            var min_distances = new Float64Array(2);
            var min_pt = new OpenSeadragon.Point(this._min_x, this._min_y);
            var max_pt = new OpenSeadragon.Point(this._max_x, this._max_y);

            var i, current_pt, distance_to_min, distance_to_max;
            for (i = 0; i < n; i++) {
                current_pt = new OpenSeadragon.Point(this._x_coordinates[i], this._y_coordinates[i]);
                distance_to_min = current_pt.distanceTo(min_pt);
                distance_to_max = current_pt.distanceTo(max_pt);

                if (i == 0) {
                    min_distances[0] = distance_to_min;
                    min_distances[1] = distance_to_max;
                }
                else {
                    if (distance_to_min < min_distances[0]) {
                        min_distances[0] = distance_to_min;
                        this._extrema_vp_indices[0] = i;
                    }

                    if (distance_to_max < min_distances[1]) {
                        min_distances[1] = distance_to_max;
                        this._extrema_vp_indices[1] = i;
                    }
                }
            }

            var min_pt_vp = new OpenSeadragon.Point(this._x_coordinates[this._extrema_vp_indices[0]], this._y_coordinates[this._extrema_vp_indices[0]]);
            var max_pt_vp = new OpenSeadragon.Point(this._x_coordinates[this._extrema_vp_indices[1]], this._y_coordinates[this._extrema_vp_indices[1]]);

            var min_pt_proj = new OpenSeadragon.Point(this._proj_x_coordinates[this._extrema_vp_indices[0]], this._proj_y_coordinates[this._extrema_vp_indices[0]]);
            var max_pt_proj = new OpenSeadragon.Point(this._proj_x_coordinates[this._extrema_vp_indices[1]], this._proj_y_coordinates[this._extrema_vp_indices[1]]);

            this._vp_length = min_pt_vp.distanceTo(max_pt_vp);
            this._proj_length = min_pt_proj.distanceTo(max_pt_proj);
            
            // console.log([this._vp_length, this._proj_length, this._proj_length / this._vp_length]);
        },

        check_bounds_viewport: function(x,y) {
            var pt = new OpenSeadragon.Point(x,y);
            // todo make tolerance configurable
            return this._is_in_rect_tolerance(pt, this._vp_bounding_rect, 0.1);
        },

        check_bounds_gps: function(lon,lat) {
            if (this._has_linear_transformation) {
                return true;
            }

            if (this._projection) {
                var merc_xy = this._projection.forward([lon, lat]);
                var merc_pt = new OpenSeadragon.Point(merc_xy[0], merc_xy[1]);
                // 10% of bounding rect width of tolerance
                // todo make it configurable
                return this._is_in_rect_tolerance(merc_pt, this._proj_bounding_rect, 0.2);
            }

            return false;
        },

        _is_in_rect_tolerance: function(pt, rect, tolerance_factor) {
            var size = Math.max.apply(this, [rect.width, rect.height]);
            var tolerance = size*tolerance_factor;
            return rect.containsPoint(pt, tolerance);
        },

        _train: function() {
            this._estimate_bounds();

            this._variogram_model = "exponential";
            var sigma2 = 0, alpha = 1;
            this._xy2mercx_model = $.gp.train(this._proj_x_normalized, this._x_coordinates, this._y_coordinates, this._variogram_model, sigma2, alpha);
            this._xy2mercy_model = $.gp.train(this._proj_y_normalized, this._x_coordinates, this._y_coordinates, this._variogram_model, sigma2, alpha);
            this._mercxy2x_model = $.gp.train(this._x_coordinates, this._proj_x_normalized, this._proj_y_normalized, this._variogram_model, sigma2, alpha);
            this._mercxy2y_model = $.gp.train(this._y_coordinates, this._proj_x_normalized, this._proj_y_normalized, this._variogram_model, sigma2, alpha);

            this._evaluate();
            
            this._has_nlint_data = true;
        },

        _evaluate: function() {
            var i, n,max_error;
            max_error = 0.0001;
            n = this._proj_x_coordinates.length;

            for (i = 0; i < n; i++) {
                var merc_x = this._unscale(this._proj_x_normalized[i], this._min_proj_x, this._max_proj_x);
                var merc_y = this._unscale(this._proj_y_normalized[i], this._min_proj_y, this._max_proj_y);
                var x = this._x_coordinates[i];
                var y = this._y_coordinates[i];
                var lonlat = this._projection.inverse([merc_x, merc_y]);

                var vp2lonlat_result = this.vp2lonlat(x,y);
                var lonlat2vp_result = this.lonlat2vp(lonlat[0], lonlat[1]);

                var vp2lonlat_error = Math.pow(vp2lonlat_result[0] - lonlat[0], 2) + Math.pow(vp2lonlat_result[1] - lonlat[1], 2);
                var lonlat2vp_error = Math.pow(lonlat2vp_result[0] - x, 2) + Math.pow(lonlat2vp_result[1] - y, 2);


                if (vp2lonlat_error > max_error || lonlat2vp_error > max_error) {
                    console.log(i, lonlat2vp_error, vp2lonlat_error, x, y, merc_x, merc_y);
                    console.log(Math.pow(lonlat2vp_result[0] - x, 2), Math.pow(lonlat2vp_result[1] - y, 2));
                }
                // console.log(vp2lonlat_result);
                // console.log(lonlat2vp_result);
            }
        },

        _scale: function(value, interval_min, interval_max) {
            return (value - interval_min) / (interval_max - interval_min);
            // return value;
        },
        _unscale: function(value, interval_min, interval_max) {
            return ( value * (interval_max - interval_min) ) + interval_min;
            // return value;
        },

        _load_from_lint_data: function(lint_data) {
            this._has_lint_data = true;
            this._viewport_coordinates = lint_data[0];
            this._mercator_coordinates = lint_data[1];

            // 学習配列の準備
            this._x_coordinates = [];
            this._y_coordinates = []; 
            this._viewport_coordinates.forEach(function(element) {
                this._x_coordinates.push(element[0]);
                this._y_coordinates.push(element[1]);
            }, this); 

            this._proj_x_coordinates = [];
            this._proj_y_coordinates = [];
            this._mercator_coordinates.forEach(function(element) {
                this._proj_x_coordinates.push(element[0]);
                this._proj_y_coordinates.push(element[1]);
            }, this);

            this._estimate_bounds();
            // this._set_projected_coordinates_bounds();
            
            
            this._train();
        },
 
        getNearestTriangle: function(x, y, projected) {
            var entries = [];
            var projected = typeof(projected) === "undefined" ? false : projected;

            var n = this._x_coordinates.length;
            var i, x_item, y_item;
            for(i = 0; i < n; i++) { 
                if (projected) {
                    x_item = this._proj_x_coordinates[i];
                    y_item = this._proj_y_coordinates[i];
                }
                else {
                    x_item = this._x_coordinates[i];
                    y_item = this._y_coordinates[i];
                }

                entries.push({
                    x: this._x_coordinates[i],
                    y: this._y_coordinates[i],
                    proj_x: this._proj_x_coordinates[i],
                    proj_y: this._proj_y_coordinates[i],
                    distance: Math.sqrt(Math.pow(x-x_item,2) + Math.pow(y-y_item, 2))
                }); 
            }

            entries.sort(function(a,b){
                return a.distance - b.distance;
            }); 

            var angle = function(pt_a, pt_b, pt_c, projected) {
                var x_field = "x";
                var y_field = "y";

                if (projected) {
                    x_field = "proj_x";
                    y_field = "proj_y";
                } 

                var a_c = {x: pt_a[x_field] - pt_c[x_field], y: pt_a[y_field] - pt_c[y_field]};
                var b_c = {x: pt_b[x_field] - pt_c[x_field], y: pt_b[y_field] - pt_c[y_field]};
                var a_c_norm = Math.sqrt(Math.pow(a_c.x,2) + Math.pow(a_c.y,2));
                var b_c_norm = Math.sqrt(Math.pow(b_c.x,2) + Math.pow(b_c.y,2));

                return (180/Math.PI) * Math.acos( (a_c.x * b_c.x + a_c.y * b_c.y) / (a_c_norm * b_c_norm)) ;
            };

            // // return a valid triangle
            // var retval = [entries[0], entries[1]];
            // var i, entry;
            // for(i = 2; i < entries.length; i++) {
            //     entry = entries[i];
            //     var angle_0 = angle(retval[0], retval[1], entry, projected);
            //     var angle_1 = angle(retval[1], entry,     retval[0], projected);
            //     var angle_2 = angle(entry,     retval[0],     retval[1], projected);

            //     if (angle_0 <= 120 && angle_1 <= 120 && angle_2 <= 120) {
            //         retval.push(entry);
            //     }
            // }

            var retval = (function or(t, e) {
                if (t.length < 3)
                    return null;
                for (var n = e ? "x" : "proj_x", i = e ? "y" : "proj_y", o = [t[0]], a = -1, s = 1; s < t.length; s++)
                    if (t[0][n] !== t[s][n] || t[0][i] !== t[s][i]) {
                        a = s,
                        o.push(t[s]);
                        break
                    }
                if (2 !== o.length)
                    return null;
                for (var u = [], l = a + 1; l < t.length; l++)
                    if ((t[a][n] !== t[l][n] || t[a][i] !== t[l][i]) && !(t[0][n] === t[a][n] && t[a][n] === t[l][n] || t[a][n] != t[0][n] && t[l][n] != t[0][n] && (t[a][i] - t[0][i]) / (t[a][n] - t[0][n]) == (t[l][i] - t[0][i]) / (t[l][n] - t[0][n]))) {
                        var c = {x: t[0][n], y:t[0][i]}
                          , h = {x: t[a][n], y:t[a][i]}
                          , d = {x: t[l][n], y:t[l][i]};
                        if (u.push(t[l]),
                        angle(c, h, d) <= 120 && angle(h, d, c) <= 120 && angle(d, c, h) <= 120) {
                            o.push(t[l]);
                            // console.log(`(${c.x}, ${c.y}), (${h.x}, ${h.y}), (${d.x},${d.y})`);
                            break;
                        }
                    }
                return 3 !== o.length && o.push(u[0]),
                o
            })(entries, !projected);

            // function or(t, e) {
            //     if (t.length < 3)
            //         return null;
            //     for (var n = e ? "x" : "mercX", i = e ? "y" : "mercY", o = [t[0]], a = -1, s = 1; s < t.length; s++)
            //         if (t[0][n] !== t[s][n] || t[0][i] !== t[s][i]) {
            //             a = s,
            //             o.push(t[s]);
            //             break
            //         }
            //     if (2 !== o.length)
            //         return null;
            //     for (var u = [], l = a + 1; l < t.length; l++)
            //         if ((t[a][n] !== t[l][n] || t[a][i] !== t[l][i]) && !(t[0][n] === t[a][n] && t[a][n] === t[l][n] || t[a][n] != t[0][n] && t[l][n] != t[0][n] && (t[a][i] - t[0][i]) / (t[a][n] - t[0][n]) == (t[l][i] - t[0][i]) / (t[l][n] - t[0][n]))) {
            //             var c = new r(t[0][n],t[0][i])
            //               , h = new r(t[a][n],t[a][i])
            //               , d = new r(t[l][n],t[l][i]);
            //             if (u.push(t[l]),
            //             r.GetAngle(c, h, d) <= 120 && r.GetAngle(h, d, c) <= 120 && r.GetAngle(d, c, h) <= 120) {
            //                 o.push(t[l]);
            //                 break
            //             }
            //         }
            //     return 3 !== o.length && o.push(u[0]),
            //     o
            // }

            return retval;
        },

        _reset: function() {
            this._x_coordinates = [];
            this._y_coordinates = [];
            this._proj_x_coordinates = [];
            this._proj_y_coordinates = [];
            this._proj_x_normalized = [];
            this._proj_y_normalized = [];
            this._mercator_coordinates = [];
            this._viewport_coordinates = [];
        },

        getProjection: function() {
            return this._projection;
        },

        _load_from_biharmonic_data: function (data) {
            this._biharmonic = new $.Mapper(data);
            
            var projected_viewport = data.biharmonic.projected_viewport;
            var viewport_projected = data.biharmonic.viewport_projected; 
                
            var i, xy = projected_viewport.control;
            this._x_coordinates = new Array(xy.length);
            this._y_coordinates = new Array(xy.length);
            for (i = 0; i < xy.length; i++) {
                this._x_coordinates[i] = xy[i][0];
                this._y_coordinates[i] = xy[i][1];
            }

            var proj_xy = viewport_projected.control;
            this._proj_x_coordinates = new Array(proj_xy.length);
            this._proj_y_coordinates = new Array(proj_xy.length);
            for (i = 0; i < proj_xy.length; i++) {
                this._proj_x_coordinates[i] = proj_xy[i][0];
                this._proj_y_coordinates[i] = proj_xy[i][1];
            }

            this._estimate_bounds();

            this._has_biharmonic_data = true;
        },

        _load_from_trained_data: function (data) { 
            this._gps_mapping_model = new $.GPSMappingGPR(data);
            var xy = data.trained_data.xy;
            var merc_xy = data.trained_data.merc_xy;

            var i;
            this._x_coordinates = new Array(xy.length);
            this._y_coordinates = new Array(xy.length);
            for (i = 0; i < xy.length; i++) {
                this._x_coordinates[i] = xy[i][0];
                this._y_coordinates[i] = xy[i][1];
            }

            this._proj_x_coordinates = new Array(merc_xy.length);
            this._proj_y_coordinates = new Array(merc_xy.length);
            for (i = 0; i < merc_xy.length; i++) {
                this._proj_x_coordinates[i] = merc_xy[i][0];
                this._proj_y_coordinates[i] = merc_xy[i][1];
            }

            this._estimate_bounds(); 
            this._has_trained_data = true;
        },
    };

    // add events
    Emitter($.Localization.prototype);
    
})(ABDOMap);
